import config from 'enasops/config'
import app from './app'
import common from './common'
import enums from './enums'
import route from './route'
import storage from './storage'
import evt from './evt'
import * as modules from './modules'

export default {
  app,
  common,
  config,
  enums,
  route,
  storage,
  evt,
  ...modules,
}